import { render } from "./InboxSolicitudes.vue?vue&type=template&id=3050060e"
import script from "./InboxSolicitudes.vue?vue&type=script&lang=js"
export * from "./InboxSolicitudes.vue?vue&type=script&lang=js"

import "./InboxSolicitudes.vue?vue&type=style&index=0&id=3050060e&lang=css"

import exportComponent from "/Users/maguilar/Dev/repos/garantias-transelec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__